import { Component, forwardRef } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../utils/pagination";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../actions/fillCombo_action';
import AdminDrawer from "../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";
import { getAccountExitPassList_action, dismantleStallHM_action, insertDamage_action, getExitPassPdf_action, getDamageDetails_action } from "../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";
import { exhibitionId, serviceTypeId, DOC_BASE_URL, toastError, downloadReport, fetchAuthReport, toastSuccess, HallZoneActionId, contractorListActionId, HallListActionId, HallZoneListActionId } from "../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import AdminHeader from '../../common_components/admin_module_header';
import { axiosGet, axiosPost } from "../../react_axios/Axios";
import Resizer from "react-image-file-resizer";
import ImageCapture from '../../utils/ImageCapture';
import moment from 'moment';
import ConfirmationModal from "../../common_components/confirmationa_modal";

class HMExitPassList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isOpen: false,
            QrCodeImg: '',
            accountExitPassList: [],
            contractorList: [],
            hallList: [],
            zoneList: [],
            currentPage: 1,
            ExitNo: '',
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            ContractorCompanyName: '',
            dismantlePop: false,
            exhID: '',
            tcomp: '',
            tpending: '',
            mainList: [],
            camNp: '',
            imgarr: [],
            damagePop: false,
            damagePop2: false,
            damageRemark: '',

            damageDocPath1: '',
            damageDocName1: '',
            damageDocFile1: '',
            damageDocType1: '',

            damageDocPath2: '',
            damageDocName2: '',
            damageDocFile2: '',
            damageDocType2: '',

            damageDocPath3: '',
            damageDocName3: '',
            damageDocFile3: '',
            damageDocType3: '',

            damageDocErr: '',
            isImageModal: false,
            remarkErr: '',
            vendorId: '',
            ExhExitPassHdrID: '',
            showVideoModal: false,
            isLastExitPass: false,
            isLastExitPassPop: false,

            exhNo: '',
            exhname: '',
            damageMarked: '',
            DamageDate: '',
        }
        this.getAccountExitPassList = this.getAccountExitPassList.bind(this)
        this.renderList = this.renderList.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.onViewExitPass = this.onViewExitPass.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.onFilterClick = this.onFilterClick.bind(this)
        this.onDismantleStall = this.onDismantleStall.bind(this)
        this.onPassDownload = this.onPassDownload.bind(this)
        this.onPassPrint = this.onPassPrint.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.markAsDamage(0)
            }
            if (confirmationObj.action == 1) {
                this.markAsDamage(1)
            }
            if (confirmationObj.action == 2) {
                this.onPassDownload(popArg[0])
            }
            if (confirmationObj.action == 3) {
                this.onPassPrint(popArg[0])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        this.getFillList(HallListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(HallZoneListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(contractorListActionId, '', '', '', '', '').then(() => {
            this.getAccountExitPassList()
        })

    }


    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === HallListActionId) {
                            this.setState({ hallList: data.data })
                            resolve()

                        }
                        if (actionID === HallZoneListActionId) {
                            this.setState({ zoneList: data.data })
                            resolve()

                        }
                        if (actionID === contractorListActionId) {
                            const array = []
                            data.data.map((item, i) => {
                                array.push(item)
                            })
                            array.push({ ContractorID: 0, CompanyName: 'Other' })
                            this.setState({
                                contractorList: array,
                                //  isLoading: false,
                            }, () => {
                                resolve(array)
                            })
                        }
                    }
                })
        })
    }

    getDamageDetails(exhid, venid, no, name, DamageMarkedBy, DamageDate, ExhExitPassHdrID) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        this.setState({ isLoading: true })
        this.props.getDamageDetails_action('', 3, exhid, venid, ExhExitPassHdrID)
            .then((data) => {
                if (data.error != 1) {
                    // this.setState({ damageList: data.data[0] })
                    var list = data.data[0]
                    var docList = []
                    for (var i = 0; i < list.length; i++) {
                        docList.push(`${DOC_BASE_URL + list[i].DocumentPath}`)
                    }
                    this.setState({
                        isLoading: false, damagePop2: true, exhNo: no, exhname: name, damageRemark: data.data[0][0].Remark, imgarr: docList, damageMarked: DamageMarkedBy,
                        DamageDate: DamageDate
                    })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getAccountExitPassList() {
        const { isLoading, ExitNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, contractorList, accountExitPassList, ContractorCompanyName } = this.state
        this.setState({ isLoading: true })
        this.props.getAccountExitPassList_action(ExitNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, ContractorCompanyName)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data.length > 0) {
                    // if (data.data[0].length > 0) {
                    data.data.map(item => {
                        item.ContractorCompanyName = ''
                        if (item.VendorID != '' && item.VendorID != '') {
                            contractorList.map(item2 => {
                                if (item.VendorID == item2.ContractorID) {
                                    item.ContractorCompanyName = item2.CompanyName
                                }
                            })
                        }
                    })
                    var temppemding = 0
                    var tempcomp = 0
                    // if (data.data[0].length > 0) {
                    data.data.map(item => {
                        if (item['IsDismantled'] == 1) {
                            tempcomp = tempcomp + 1
                        } else {
                            temppemding = temppemding + 1
                        }
                    })
                    // var tempArr = data.data.length > 0 ? data.data.filter(item => item.ExitPassStatus == 'Approved') : []
                    this.setState({ accountExitPassList: data.data, mainList: data.data, tcomp: tempcomp, tpending: temppemding })
                    // }
                    // }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onViewExitPass(vendorID, ExhID, exitId, otherInfo, isVendor, ExitNo) {
        const { isLoading, HallId, ZoneId, ExhRegistrationNo, CompanyName, accountExitPassList } = this.state
        this.props.navigate('/exitPass', { state: { is_view: true, isExhibitor: vendorID == null ? true : false, regId: ExhID, vendorID: vendorID, exitId: exitId, otherInfo: vendorID == 0 ? otherInfo : null, isVendor: isVendor, ExitNo: ExitNo } })
    }

    onPassDownload(id) {
        console.log(id);
        this.setState({ isLoading: true });
        this.props
            .getExitPassPdf_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false });
                    console.log("Proforma Pdf Download", data);
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, "_blank");
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
    async onPassPrint(id) {
        console.log(id);
        this.setState({ isLoading: true });
        try {
            var list = [];
            const mapdata1 = {
                ParameterName: "@ExhExitpassHdrID",
                ParameterValue: id,
                ParameterDataType: "int",
            };
            list.push(mapdata1);
            const mapData = {
                report_name: "ExitPass.rpt",
                parameter_details: list,
            };
            console.log("xxxxxxxxxxxxxxxxxxxxx", mapData);
            const res = await axiosPost(fetchAuthReport, mapData);
            this.setState({ isLoading: false });

            if (res != null) {
                var url = `${downloadReport}?SessionIdentifier=${res}`;
                const win = window.open(url, "_blank", "noopener,noreferrer");
                if (win != null) {
                    win.focus();
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    renderList(currentRecords) {
        const { isLoading, ExitNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, accountExitPassList } = this.state
        return (
            <>
                <div className="table-responsive">
                    <table class="table table-bordered align-middle">
                        <thead class="table-light">
                            <tr>
                                <th class="text-center" style={{ width: '250px', }}>Exit No</th>
                                <th class="text-center" >Hall</th>
                                <th class="text-center" >Zone</th>
                                <th class="text-center" >Stall</th>
                                <th>Exhibitor Details</th>
                                <th style={{ width: '250px' }}>Contractor Details</th>
                                <th class="text-center" style={{ width: '250px' }}>Dismantle Status</th>
                                {/* <th class="text-center" style={{ width: '90px' }}>Material Exit pass Status</th> */}
                                <th class="text-center" style={{ width: '90px' }}>Damage Status</th>
                                <th class="text-center" style={{ width: '100px', }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRecords.length > 0 ? currentRecords.map(item => (
                                <tr>
                                    <td class="text-center">{item['Exit No']}</td>
                                    <td class="text-center hall-td">{item['Hall']}</td>
                                    <td class="text-center">{item['Zone']}</td>
                                    <td class="text-center">{item['Stall']}</td>
                                    <td><span style={{ fontWeight: "600" }}>{item['ExhRegistrationNo']}</span> <br />{item['Exhibitor Details']}</td>
                                    <td class="vendor p-1 ">
                                        {item.VendorID != null ? <div>
                                            {item?.ContractorCompanyName && (
                                                <span className="my-1 mt-0 ha-view-com fw-bold vendor-info-text">
                                                    <i className="fa fa-solid fa-building text-dark"></i>&nbsp;
                                                    {item.ContractorCompanyName}
                                                </span>
                                            )}
                                            {/* <br /> */}
                                            {item['Person Name'] != null && <span class="mt-0"><i class="ri-user-3-line grid-icon"></i>&nbsp; {item['Person Name']} </span>}
                                            <br />
                                            {item['Mobile Number'] != null && <span class=""> <i class="ri-phone-line grid-icon"></i>
                                                &nbsp; {item['Mobile Number']}  </span>}
                                            <br />
                                            {item['Email ID'] != null && <span> <i class="ri-mail-line grid-icon"></i>
                                                &nbsp; {item['Email ID']} </span>}
                                            <br />
                                        </div> : ''}
                                    </td>
                                    <td class={item['IsDismantled'] == 1 ? 'text-center' : 'text-center grid-icon'} style={{ cursor: 'default' }}>{item['IsDismantled'] == 1 ? 'Dismantled' : 'Pending for Dismantle'}</td>
                                    {/* <td class={item.ExitPassStatus == 'Rejected' ? "text-center text-danger" : item.ExitPassStatus == 'Approved' ? "text-center text-aqua" : 'text-center text-aqua'}>{item['ExitPassStatus']}</td> */}
                                    <td class={item.isDamaged ? "text-center text-danger" : "text-center text-aqua"} style={{ cursor: 'default' }}>{item['isDamaged'] ? 'Damaged' : 'Not Damaged'}</td>
                                    <td class={item.ExitPassStatus == 'Approved' ? "text-left act-col" : "text-left act-col"}>
                                        <a style={{ cursor: 'pointer' }} class="border-end pe-1 me-1" onClick={() => this.onViewExitPass(item.VendorID, item.ExhRegistrationID, item.ExhExitPassHdrID,
                                            {
                                                companyName: item['Exhibitor Details'],
                                                personName: item['Person Name'],
                                                contactNo: item['Mobile Number'],
                                                email: item['Email ID']
                                            },
                                            item.isVendor, item['Exit No']
                                        )}>
                                            <i class="bi bi-eye fs-6 grid-icon p-1 rounded-1 px-1 fw-normal" title="View Material Exit pass"></i>
                                        </a>
                                        {item.StatusID != 4 && <i style={{ cursor: 'pointer' }} class="ri-download-line fs-6  p-1 rounded-1 px-1 fw-normal border-end pe-2 me-1 grid-icon"
                                            // onClick={() => this.onPassDownload(item.ExhExitPassHdrID)}
                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 2 }, popArg: [item.ExhExitPassHdrID] })}
                                        ></i>}
                                        {item.StatusID != 4 && <i style={{ cursor: 'pointer' }} class="ri-printer-line fs-6 p-1 rounded-1 px-1 fw-normal border-end pe-2 me-1 grid-icon"
                                            // onClick={() => this.onPassPrint(item.ExhExitPassHdrID)}
                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 3 }, popArg: [item.ExhExitPassHdrID] })}
                                        ></i>}
                                        {item.StatusID != 4 && <a style={{ cursor: 'pointer' }} onClick={() => {
                                            if (item.QRcodeImg) {
                                                const byteArray = item.QRcodeImg.data || item.QRcodeImg;
                                                const base64 = btoa(String.fromCharCode(...byteArray));
                                                this.setState({ QrCodeImg: `data:image/png;base64,${base64}`, isOpen: true });
                                            }
                                        }}>
                                            <i class="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-1 fw-normal qrIcon" title="Scan to Print"></i>
                                        </a>}
                                        {item['IsDismantled'] != 1 ? <i class="bi bi-tools fs-7 grid-icon p-1 rounded-1 px-1 fw-normal" style={{ cursor: 'pointer' }} onClick={() => this.setState({ dismantlePop: true, exhID: item.ExhRegistrationID, ExhExitPassHdrID: item.ExhExitPassHdrID, vendorId: item.VendorID })} title="Tag as Dismantled"></i> : <></>}
                                        {<i style={{ cursor: 'pointer' }} class={item.isDamaged ? "bi bi-exclamation-triangle-fill text-aqua  p-1 border-end pe-2 me-1" : "fa fa-exclamation-triangle  p-1 rounded-1 px-1 fw-normal border-end pe-2 me-1 grid-icon"} onClick={() => item.isDamaged ? this.getDamageDetails(item['ExhRegistrationID'], item.VendorID, item.ExhRegistrationNo, item.ExhibitorName, item.DamageMarkedBy, item.DamageDate, item.ExhExitPassHdrID) : this.setState({ isLastExitPassPop: true, exhID: item.ExhRegistrationID, ExhExitPassHdrID: item.ExhExitPassHdrID, vendorId: item.VendorID, mailData: { ExitNo: item['Exit No'], PrimaryEmail: item.ExhRegistrationID != '' && item.ExhRegistrationID != null ? item.ExhEmail : item['Email ID'], person: item.ExhRegistrationID != '' && item.ExhRegistrationID != null ? item.ExhPersonName : item['Person Name'] } })} title={item.isDamaged ? "View Damage" : "Approve Damage"}></i>}
                                    </td>
                                </tr>
                            )) : <tr>
                                <td colSpan={12} className="text-center">Record not found</td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

    // Update Current Page
    updateItem(item) {
        const { accountExitPassList } = this.state
        this.setState({ currentPage: item });
    }
    clearValue() {
        this.setState({
            ExitNo: '',
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            ContractorCompanyName: '',
        })
        setTimeout(() => {
            this.getAccountExitPassList()
        }, 100);
    }

    markAsDamage(isDamage) {
        const { isLoading, ExitNo, damageDocErr, damageDocFile1, ExhExitPassHdrID, damageDocFile2, damageDocFile3, damageDocName1, damageDocName2, damageDocName3, damageDocPath1, damageDocPath2, damageDocPath3, damageDocType1, damageDocType2, damageDocType3, damageRemark, HallId, ZoneId, isOpen, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, isLastExitPass, vendorId, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, exhID, damagePop } = this.state
        var Err = false
        var damagedocArr = []
        if (damagePop && isDamage) {
            if (damageRemark == '' || damageRemark == null) {
                this.setState({
                    remarkErr: 'Please enter Remark'
                })
                Err = true

            }
            if (damageDocFile1 != '' && damageDocFile1 != null) {
                damagedocArr.push({ damageDocPath: damageDocPath1, damageDocName: damageDocName1, damageDocFile: damageDocFile1, damageDocType: damageDocType1, Remark: damageRemark })
            }
            if (damageDocFile2 != '' && damageDocFile2 != null) {
                damagedocArr.push({ damageDocPath: damageDocPath2, damageDocName: damageDocName2, damageDocFile: damageDocFile2, damageDocType: damageDocType2, Remark: damageRemark })
            }
            if (damageDocFile3 != '' && damageDocFile3 != null) {
                damagedocArr.push({ damageDocPath: damageDocPath3, damageDocName: damageDocName3, damageDocFile: damageDocFile3, damageDocType: damageDocType3, Remark: damageRemark })
            }
            if (damagedocArr.length == 0) {
                this.setState({
                    damageDocErr: 'Please enter atleast 1 image'
                })
                Err = true
            }
        }
        if (Err) {
            toastError("Enter mandatory fields")
            return
        } else {
            this.setState({ isLoading: true, })
            this.props
                .insertDamage_action(exhID, vendorId, isDamage ? damagedocArr : [], ExhExitPassHdrID, isLastExitPass)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false, dismantlePop: false, damagePop: false })
                        this.setState({
                            damageDocPath1: '',
                            damageDocName1: '',
                            damageDocFile1: '',
                            damageDocType1: '',
                            damageRemark: '',
                            damageDocPath2: '',
                            damageDocName2: '',
                            damageDocFile2: '',
                            damageDocType2: '',
                            damageDocType3: '',
                            damageDocName3: '',
                            damageDocFile3: '',
                            damageDocType3: '',
                        })
                        toastSuccess("Updated successfully")
                        this.getAccountExitPassList()
                    }
                    this.setState({ isLoading: false, })
                }).catch((e) => {
                    console.log(e);
                });
        }
    }

    onDismantleStall() {
        const { isLoading, ExitNo, damageDocErr, damageDocFile1, ExhExitPassHdrID, damageDocFile2, damageDocFile3, damageDocName1, damageDocName2, damageDocName3, damageDocPath1, damageDocPath2, damageDocPath3, damageDocType1, damageDocType2, damageDocType3, damageRemark, HallId, ZoneId, isOpen, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, vendorId, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, exhID, damagePop } = this.state

        this.setState({ isLoading: true, })
        this.props
            .dismantleStallHM_action(exhID, vendorId, [], ExhExitPassHdrID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, dismantlePop: false, damagePop: false })
                    toastSuccess("Tagged dismantled successfully")
                    this.getAccountExitPassList()
                } else {
                    // was silent - "Yes" looked like it did nothing
                    toastError(data.msg || 'Could not tag the stall as dismantled')
                }
                this.setState({ isLoading: false, })
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false })
                toastError('Something went wrong...')
            });
    }

    onFilterClick(mode) {
        const { isLoading, ExitNo, HallId, ZoneId, isOpen, mainList, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, tcomp, tpending } = this.state
        console.log("pppp")
        var templist
        if (mode == 0) {
            templist = mainList.filter(item => item['IsDismantled'] == 1)
        } else {
            templist = mainList.filter(item => item['IsDismantled'] != 1)
        }
        this.setState({ accountExitPassList: templist })
    }

    handleCapture = (imageData) => {
        const { VendorIndex, camNp } = this.state
        if (camNp == 1) {
            this.setState({
                damageDocPath1: '',
                damageDocName1: 'Document1',
                damageDocFile1: imageData,
                damageDocType1: 'jpeg',
                damageDocErr: '',
            })
        }
        if (camNp == 2) {
            this.setState({
                damageDocPath2: '',
                damageDocName2: 'Document2',
                damageDocFile2: imageData,
                damageDocType2: 'jpeg',
                damageDocErr: '',
            })
        }
        if (camNp == 3) {
            this.setState({
                damageDocPath3: '',
                damageDocName3: 'Document3',
                damageDocFile3: imageData,
                damageDocType3: 'jpeg',
                damageDocErr: '',
            })
        }
        this.setState({ isImageModal: false })
    };



    renderNewImage = (img, type) => {
        const { imageBase64 } = this.state;
        if (type == 'pdf') {
            // window.open(img, "_blank")

            const base64 = img;
            const pdfData = atob(base64.split(",")[1]); // decode Base64

            const len = pdfData.length;
            const uintArray = new Uint8Array(new ArrayBuffer(len));
            for (let i = 0; i < len; i++) {
                uintArray[i] = pdfData.charCodeAt(i);
            }

            const blob = new Blob([uintArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            window.open(url, "_blank"); // open in new tab

        } else {
            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write(
                    `<img src="${img}" style="width:100%;height:auto;" />`
                );
            } else {
                alert("Please allow popups for this website");
            }
        }
    };


    onFilePick = async (e, file, num) => {
        e.preventDefault()
        const { } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        if (num == 1) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        } else if (num == 2) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile2: image, damageDocName2: file[0]['name'].toString() })
                        } else if (num == 3) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile3: image, damageDocName3: file[0]['name'].toString() })
                        }
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        if (num == 1) {
                            this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        } else if (num == 2) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile2: image, damageDocName2: file[0]['name'].toString() })
                        } else if (num == 3) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile3: image, damageDocName3: file[0]['name'].toString() })
                        }
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    if (num == 1) {
                        // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        this.setState({ damageDocType1: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
                    } else if (num == 2) {
                        // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        this.setState({ damageDocType2: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
                    } else if (num == 3) {
                        // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        this.setState({ damageDocType3: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
                    }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });
    onCrossClick(num) {
        if (num == 1) {
            // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
            // this.setState({ damageDocType1: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
            this.setState({ damageDocFile1: "", damageDocName1: "" })
            document.getElementById("fileDoc1").value = ""
        }
    }

    render() {
        const { isLoading, ExitNo, isLastExitPass, isLastExitPassPop, ExhExitPassHdrID, remarkErr, HallId, ZoneId, isOpen, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, tcomp, tpending, damageDocPath1, damageDocName1, damageDocFile1, damageDocType1, damageDocPath2, imgarr, damageDocName2, damageDocFile2, damageDocType2, damageDocPath3, isImageModal, damageDocName3, damageDocFile3, damageDocType3, damageDocErr, isOpenConfirmationModal } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = accountExitPassList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(accountExitPassList.length / recordsPerPage)
        console.log(ExhExitPassHdrID)
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <AdminHeader />
                {/* <HeaderWithLogo /> */}
                <>
                    {/* <AdminDrawer /> */}
                    {/* <div className="app-content with-dr-container com-height"> */}

                    <div className="page-scroll">
                        <div className="main-content com-height hm-top-space">
                            <main id="main" class="px-3 py-2">
                                {this.state.showVideoModal && (
                                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
                                        <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Material Exit pass</h5>
                                                    <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                                                </div>
                                                <div className="modal-body">
                                                    <video controls autoPlay style={{ width: '100%' }}>
                                                        <source src="/assets/ExitPass.mp4" type="video/mp4" />
                                                    </video>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* <div class="pagetitle d-flex justify-content-between border-bottom pb-2">
                                <nav>
                                    <ol class="breadcrumb mb-0" style={{ background: 'none' }}>
                                        <li class="breadcrumb-item fw-bolder pt-2" style={{ background: 'none' }}>Material Exit pass</li>
                                    </ol>
                                </nav>
                            </div> */}
                                <section class="section p-0" >
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="">
                                                <form>
                                                    <div className="d-flex justify-content-end mb-2">
                                                        {/* <span
                                                            onClick={() => this.setState({ showVideoModal: true })}
                                                            style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px' }}
                                                        >
                                                            <i className="bi bi-play-circle-fill me-2"></i>User Manual
                                                        </span> */}
                                                    </div>
                                                    <div className="main-container p-2">
                                                        <div className="row ">
                                                            <div className="col-lg-2 mb-2">
                                                                <label class="">Exit No</label>
                                                                <input type="text" class="form-control form-control-sm w-100" value={ExitNo} onChange={(e) => this.setState({ ExitNo: e.target.value })} />
                                                            </div>

                                                            <div className="col-lg-2 mb-2">
                                                                <label >Hall</label>
                                                                <select
                                                                    className="form-control form-control-sm w-100"
                                                                    id="roledb"
                                                                    style={{ textAlign: "left" }}
                                                                    value={HallId}
                                                                    // disabled={isView || isReadOnly}
                                                                    onChange={(e) => this.setState({ HallId: e.target.value })}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {hallList.length > 0 && hallList.map((data) => (
                                                                        <option key={data.HallId} value={data.HallId}>{data.HallName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-lg-2 mb-2">
                                                                <label >Zone</label>
                                                                <select
                                                                    className="form-control form-control-sm w-100"
                                                                    id="roledb"
                                                                    style={{ textAlign: "left" }}
                                                                    value={ZoneId}
                                                                    // disabled={isView || isReadOnly}
                                                                    onChange={(e) => this.setState({ ZoneId: e.target.value })}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {zoneList.length > 0 && zoneList.map((data) => (
                                                                        <option key={data.ZoneID} value={data.ZoneID}>{data.Zone}</option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-lg-2 mb-2">
                                                                <label >Exhibitor Reg. No.</label>
                                                                <input type="text" class="form-control form-control-sm w-100" value={ExhRegistrationNo} onChange={(e) => this.setState({ ExhRegistrationNo: e.target.value })} />
                                                            </div>

                                                            <div className="col-lg-2 mb-2">
                                                                <label >Exhibitor</label>
                                                                <input type="text" class="form-control form-control-sm w-100" value={CompanyName} onChange={(e) => this.setState({ CompanyName: e.target.value })} />
                                                            </div>

                                                            <div className="col-lg-2 mb-2">
                                                                <label >Contractor</label>
                                                                <input type="text" class="form-control form-control-sm w-100" value={ContractorCompanyName} onChange={(e) => this.setState({ ContractorCompanyName: e.target.value })} />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-end">
                                                            <div className="d-flex gap-2" role="group" aria-label="Basic example">
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-aqua mx-1 list-btn"
                                                                    onClick={(e) => this.getAccountExitPassList()}>
                                                                    Search
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-gray  list-btn"
                                                                    onClick={() => this.clearValue()}>
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div class="d-flex justify-content-between align-items-center w-100">
                                                        <div class="d-flex align-items-center">
                                                            <div class="d-flex align-items-center px-3 py-1 bg-white border rounded small mx-2">
                                                                <i class="bi bi-tools me-1 fs-7"></i>
                                                                <span class="text-muted"> Dismantled:</span>
                                                                <strong class="ms-1">5</strong>
                                                            </div>

                                                            <div class="d-flex align-items-center px-3 py-1 bg-white border rounded small mx-2">
                                                                <i class="bi bi-hourglass-split grid-icon me-1 fs-7"></i>
                                                                <span class="text-muted">Pending for Dismantle:</span>
                                                                <strong class="ms-1 grid-icon">3</strong>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <div class="d-flex justify-content-end align-items-center w-100 mb-1">
                                                        <div class="d-flex align-items-center">
                                                            <div style={{ cursor: 'pointer' }} class="p-1 rounded-1 status-btn mx-2" onClick={() => this.onFilterClick(0)}>
                                                                <i class="bi bi-tools fs-7 status-name"></i>  &nbsp;
                                                                <span class="">Dismantled:</span>
                                                                <strong class="ms-1 status-name">{this.state.tcomp}</strong>
                                                            </div>

                                                            <div onClick={() => this.onFilterClick(1)} class="p-1 rounded-1 status-btn">
                                                                <i class="fa fa-hourglass-half fs-6 me-1"></i>  &nbsp;
                                                                <span class="">Pending for Dismantle:</span>
                                                                <strong class="ms-1">{this.state.tpending}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="table-freeze mt-1">

                                                        {this.renderList(accountExitPassList.length > 0 ? currentRecords : [])}
                                                        {/* //here */}
                                                    </div>
                                                    <div className="table-pagination-footer mt-2">
                                                        <div>
                                                            {accountExitPassList.length > 0 ? (
                                                                <Pagination
                                                                    nPages={nPages}
                                                                    currentPage={currentPage}
                                                                    setCurrentPage={this.updateItem}
                                                                />
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                        <div className="table-pagination-info">
                                                            <p>Page <strong>{currentPage}</strong> of <strong>{nPages}</strong></p>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </main >
                        </div>
                    </div>
                    <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header p-2">
                                    <h5 class="modal-title modal_title_text text-white">Scan below QR in Kiosk Device for print Material Exit pass</h5>
                                    {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} style={{ background: '#eeeeee' }}><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <img
                                                src={QrCodeImg}
                                                alt="QR Code"
                                                className="rounded-2xl shadow-lg w-64 h-64 object-contain"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer p-1">
                                    <div class="form-group text-right mod-fot">
                                        <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false })}>Close</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal>
                    <Modal isOpen={dismantlePop} onRequestClose={() => this.setState({ dismantlePop: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header">
                                    <h5 class="modal-title" style={{ fontSize: "16px" }}>Dismantled Record</h5>
                                    <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ dismantlePop: false })} ></button>
                                </div>
                                <div class="modal-body">
                                    Do you want to tag this stall as <strong>Dismantled?</strong>
                                </div>
                                <div class="modal-footer">
                                    {/* <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ dismantlePop: false, damagePop: true })}>Mark as Damaged</button> */}
                                    <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ dismantlePop: false })}>No</button>
                                    <button type="button" class="btn btn-aqua" onClick={() => this.onDismantleStall()}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal isOpen={isLastExitPassPop} onRequestClose={() => this.setState({ isLastExitPassPop: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header">
                                    <h5 class="modal-title" style={{ fontSize: "16px" }}>Last ExitPass</h5>
                                    <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isLastExitPassPop: false })} ></button>
                                </div>
                                <div class="modal-body">
                                    Is this the Last Material Exit pass?
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-aqua" onClick={() => this.setState({ isLastExitPassPop: false, isLastExitPass: true, damagePop: true })}>Yes</button>
                                    <button type="button" class="btn btn-gray" onClick={() => this.setState({ isLastExitPassPop: false, isLastExitPass: false, damagePop: true })}>No</button>
                                    {/* <button type="button" class="btn btn-danger" onClick={() => this.onDismantleStall()}>Yes</button> */}
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={this.state.damagePop} onRequestClose={() => this.setState({ damagePop: false })}
                    >
                        {/* <div className="modal-dialog">
                                          <div className="modal-content confirm-logout">
                                              <div class="modal-header p-2">
                                                  <h5 class="modal-title">Additional Furniture</h5>
                                                  <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                              </div>
                                              <div>
                                              </div>
                  
                                          </div>
                                      </div> */}

                        {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

                        <div class="modal-dialog modal-xl modal-dialog-centered">
                            <div className="modal-content shadow-lg border-0 rounded-4">
                                <div class="modal-header">
                                    <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                                    <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop: false })} ></button>
                                </div>
                                <div class="modal-body">
                                    <div>
                                        Do you want to tag this stall as <strong>Damaged?</strong>
                                    </div>
                                    <div class="mb-2">
                                        <label class="col-form-label">Remark<span class="text-danger">*</span></label>
                                        <textarea
                                            style={{ height: '100px !important' }}
                                            id="damageRemark"
                                            class="form-control"
                                            rows="4"
                                            placeholder="Enter reason here..."
                                            onChange={(e) =>
                                                this.setState({ damageRemark: e.target.value, remarkErr: "" })
                                            }
                                            value={this.state.damageRemark}
                                        ></textarea>
                                        <span className="text-danger text-start text-left d-block mt-1">
                                            {remarkErr}
                                        </span>
                                    </div>
                                    <div class="card-body border rounded p-2">
                                        <div class="row g-2 align-items-center">
                                            <div class="col-md-6">
                                                <label class="form-label mb-1">Capture / Upload Photo of damage 1</label>
                                                {damageDocName1 != null && damageDocName1 != '' ? <div style={{
                                                    border: '1px solid #ccc',
                                                    padding: '10px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <a
                                                        href={damageDocPath1}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {damageDocType1 != null && damageDocType1 != '' ? <span onClick={() => this.renderNewImage(damageDocFile1, damageDocType1)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                        >{damageDocName1}</span> : <span style={{ marginRight: '10px' }}
                                                        >{damageDocName1}</span>}
                                                    </a>
                                                    {<i className={`fa fa-times text-danger img-can`}
                                                        onClick={(e) => this.setState({ damageDocFile1: '', damageDocType1: '', damageDocName1: '', damageDocPath1: '' })}
                                                    ></i>}
                                                </div>
                                                    : <div class="d-flex align-items-center gap-2">
                                                        {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 1 })}>
                                                            <i class="bi bi-camera"></i> Open Camera
                                                        </button>}
                                                        {<span class="text-muted">or</span>}
                                                        {<div className="upload-options">
                                                            <label style={{ display: 'flex', margin: 0 }}>
                                                                <input
                                                                    type="file"
                                                                    id='fileDoc1'
                                                                    ref='fileDoc1'
                                                                    name='fileDoc1'
                                                                    className="image-upload"
                                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                                    onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                />
                                                            </label>
                                                        </div>}
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body border rounded p-2">
                                        <div class="row g-2 align-items-center">
                                            <div class="col-md-6">
                                                <label class="form-label mb-1">Capture / Upload Photo of damage 2</label>
                                                {damageDocName2 != null && damageDocName2 != '' ? <div style={{
                                                    border: '1px solid #ccc',
                                                    padding: '10px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <a
                                                        href={damageDocPath2}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {damageDocType2 != null && damageDocType2 != '' ? <span onClick={() => this.renderNewImage(damageDocFile2, damageDocType2)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                        >{damageDocName2}</span> : <span style={{ marginRight: '10px' }}
                                                        >{damageDocName2}</span>}
                                                    </a>
                                                    {<i className={`fa fa-times text-danger img-can`}
                                                        onClick={(e) => this.setState({ damageDocFile2: '', damageDocType2: '', damageDocName2: '', damageDocPath2: '' })}
                                                    ></i>}
                                                </div>
                                                    : <div class="d-flex align-items-center gap-2">
                                                        {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 2 })}>
                                                            <i class="bi bi-camera"></i> Open Camera
                                                        </button>}
                                                        {<span class="text-muted">or</span>}
                                                        {<div className="upload-options">
                                                            <label style={{ display: 'flex', margin: 0 }}>
                                                                <input
                                                                    type="file"
                                                                    id='fileDoc1'
                                                                    ref='fileDoc1'
                                                                    name='fileDoc1'
                                                                    className="image-upload"
                                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                                    onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                                />
                                                            </label>
                                                        </div>}
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body border rounded p-2">
                                        <div class="row g-2 align-items-center">
                                            <div class="col-md-6">
                                                <label class="form-label mb-1">Capture / Upload Photo of damage 3</label>
                                                {damageDocName3 != null && damageDocName3 != '' ? <div style={{
                                                    border: '1px solid #ccc',
                                                    padding: '10px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <a
                                                        href={damageDocPath3}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {damageDocType3 != null && damageDocType3 != '' ? <span onClick={() => this.renderNewImage(damageDocFile3, damageDocType3)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                        >{damageDocName3}</span> : <span style={{ marginRight: '10px' }}
                                                        >{damageDocName3}</span>}
                                                    </a>
                                                    {<i className={`fa fa-times text-danger img-can`}
                                                        onClick={(e) => this.setState({ damageDocFile3: '', damageDocType3: '', damageDocName3: '', damageDocPath3: '' })}
                                                    ></i>}
                                                </div>
                                                    : <div class="d-flex align-items-center gap-2">
                                                        {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 3 })}>
                                                            <i class="bi bi-camera"></i> Open Camera
                                                        </button>}
                                                        {<span class="text-muted">or</span>}
                                                        {<div className="upload-options">
                                                            <label style={{ display: 'flex', margin: 0 }}>
                                                                <input
                                                                    type="file"
                                                                    id='fileDoc1'
                                                                    ref='fileDoc1'
                                                                    name='fileDoc1'
                                                                    className="image-upload"
                                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                                    onChange={e => this.onFilePick(e, e.target.files, 3)}
                                                                />
                                                            </label>
                                                        </div>}
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-danger text-start text-left d-block mt-1">
                                        {damageDocErr}
                                    </span>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn  btn-aqua"
                                        // onClick={() => this.markAsDamage(0)}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}>Submit without Damage</button>
                                    <button type="button" class="btn btn-aqua"
                                        // onClick={() => this.markAsDamage(1)}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 1 }, popArg: [] })}>Submit Damage</button>
                                    <button type="button" class="btn btn-gray" onClick={() => this.setState({ damagePop: false })}>Cancel</button>

                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={this.state.damagePop2} onRequestClose={() => this.setState({ damagePop2: false })}
                    >
                        {/* <div className="modal-dialog">
                                                                              <div className="modal-content confirm-logout">
                                                                                  <div class="modal-header p-2">
                                                                                      <h5 class="modal-title">Additional Furniture</h5>
                                                                                      <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                                                                  </div>
                                                                                  <div>
                                                                                  </div>
                                                      
                                                                              </div>
                                                                          </div> */}

                        {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

                        <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
                            <div className="modal-content shadow-lg border-0 rounded-4">
                                <div class="modal-header">
                                    <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                                    <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop2: false })} ></button>
                                </div>
                                <div class="modal-body">
                                    <div >
                                        <strong style={{ fontSize: 'x-large' }}>{this.state.exhNo}</strong><br />
                                        <strong>{this.state.exhname}</strong><br /><br />
                                    </div>
                                    <div>
                                        Damage Marked By: <strong>{this.state.damageMarked}</strong><br />
                                        Damage Marked Date: <strong>{moment(this.state.DamageDate).format('DD/MM/YYYY')}</strong><br /><br />
                                    </div>
                                    <div>
                                        Remark: <strong>{this.state.damageRemark}</strong><br />
                                    </div>
                                    <div>
                                        Images<br />
                                        {imgarr.length > 0 && imgarr.map(item => (
                                            <img
                                                onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                                                src={item}
                                                style={{ margin: '2px', cursor: 'pointer' }}
                                                alt="Preview"
                                                width="200"
                                                height="200"
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop2: false })}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </>
                <ImageCapture
                    isOpen={isImageModal}
                    onClose={() => this.setState({ isImageModal: false })}
                    onCapture={this.handleCapture}
                />
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, dismantleStallHM_action, getExitPassPdf_action, insertDamage_action, getDamageDetails_action,
    getAccountExitPassList_action
})(HMExitPassList));